.check-animation {
  width: 1em;
  height: 1em;
  path {
    animation: check-path-animation ease-out var(--normal-s);
    stroke-linecap: round;

    stroke-width: 3px;
  }
}

@keyframes check-path-animation {
  from {
    stroke-dasharray: 0 50;
  }
  to {
    stroke-dasharray: 50;
  }
}
